<template>
  <div class="t-contract-edit-cancel-account__complete">
    <a-brand-logo variant="horizontal" class="t-contract-edit-cancel-account__complete-logo" />
    <div class="t-contract-edit-cancel-account__complete-content">
      <a-application-complete-sign class="t-contract-edit-cancel-account__complete-image">
        <img src="@/images/t-contract-edit-cancel-account.svg" />
      </a-application-complete-sign>
      <a-heading
        heading="解約のお手続きが完了しました"
        color="primary"
        size="large"
        class="t-contract-edit-cancel-account__complete-heading"
      />
      <a-text class="t-contract-edit-cancel-account__complete-text">
        解約のお手続きが完了しましたが、今月分までの料金が発生します。
      </a-text>
      <a-button
        id="goTop"
        variant="block"
        color="primary"
        label="サイトトップへ"
        class="t-contract-edit-cancel-account__complete-button"
        @click="handleGoToHome"
      />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { LP_URL } from '@/libs/constants';

export default {
  name: 't-contract-edit-cancel-complete',
  components: {},
  mixins: [],
  props: {
    class: {
      type: String,
      default: '',
    },
    handleAccountCancellationModalCloseClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-edit-cancel-account');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async created() {},
  mounted() {},
  methods: {
    handleGoToHome() {
      window.location.href = LP_URL;
    },
  },
};
</script>
